import { render, staticRenderFns } from "./yuyueorderinfo.vue?vue&type=template&id=a8d473e2&scoped=true"
import script from "./yuyueorderinfo.vue?vue&type=script&lang=js"
export * from "./yuyueorderinfo.vue?vue&type=script&lang=js"
import style0 from "./yuyueorderinfo.vue?vue&type=style&index=0&id=a8d473e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d473e2",
  null
  
)

export default component.exports